import { useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Transition from '../../components/Transition/Transition';
import React from 'react'
import {Fade, Button, Box, Typography,IconButton, Stack, Grid} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {} from "@mui/material";
import {InstagramEmbed } from 'react-social-media-embed';
import WhatsappIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Navigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';







function Event() 
{
  const [event, setEvent] = useState(null); 
  const [loading, setLoading] = useState(true); 
    const { id } = useParams();
const { t: tGlobal } = useTranslation('global');
const { t: tEvents } = useTranslation('events');


  const [showOverlay, setShowOverlay] = React.useState(false);
const [currentIndex, setCurrentIndex] = React.useState(0);
const navigate = useNavigate();

function getWeekday(id) {
  if (tEvents(id+".date").length===0) {
    return <></>;
  }
  return <Stack direciton="column" spacing={{lg:"5px", md:"5px", xs:"5px"}}>
   <Typography sx={{fontWeight:"600", color:"#CC0000", fontSize:{lg:"24px", md: "20px", xs:"20px"}}}>{tGlobal("Event.date")}</Typography>
   <Typography sx={{fontWeight:"400", color:"#000000", fontSize:{lg:"20px", md: "20px", xs:"16px"}}}>{tEvents(id+".date")}</Typography> 
  </Stack>;
}

function getVenue(id) {
  if (tEvents(id+".venue").length===0) {
    return <></>;
  }
  return <Stack direciton="column" spacing={{lg:"5px", md:"5px", xs:"5px"}}>
   <Typography sx={{fontWeight:"600", color:"#CC0000", fontSize:{lg:"24px", md: "24px", xs:"20px"}}}>{tGlobal("Event.venue")}</Typography>
   <Typography sx={{fontWeight:"400", color:"#000000", fontSize:{lg:"20px", md: "20px", xs:"16px"}}}>{tEvents(id+".venue")}</Typography> 
  </Stack>;
}

function getTime(id) {
  if (tEvents(id+".time").length===0) {
    return <></>;
  }
  return <Stack direciton="column">
   <Typography sx={{fontWeight:"600", color:"#CC0000", fontSize:{lg:"24px", md: "24px", xs:"20px"}}}>{tGlobal("Event.time")}</Typography>
   <Typography sx={{fontWeight:"400", color:"#000000", fontSize:{lg:"20px", md: "20px", xs:"16px"}}}>{tEvents(id+".time")}</Typography> 
  </Stack>;
}

function getTicket(id) {
  if (tEvents(id+".ticket").length===0) {
    return <></>;
  }
  return <Stack direciton="column">
   <Typography sx={{fontWeight:"600", color:"#CC0000", fontSize:{lg:"24px", md: "24px", xs:"20px"}}}>{tGlobal("Event.ticket")}</Typography>
   <Typography sx={{fontWeight:"400", color:"#000000", fontSize:{lg:"20px", md: "20px", xs:"16px"}}}>{tEvents(id+".ticket")}</Typography> 
  </Stack>;
}

function getTicketing(ticketing, isticketable) {
  if (ticketing.length===0) {
    return <></>;
  }
  return     <Button 
  variant="contained"
  href={ticketing}
  disabled={!isticketable}
  sx={{
    width:{lg:"300px", md:"300px", xs:"300px"},
    height:{lg:"45px", md:"45px", xs:"45px"},
    
    bgcolor:"#ffffff",
    borderRadius:"10px",
    color:'#ee0000',
    textTransform: 'none',
    fontSize:{lg:"18px", md:"18px", xs:"18px"},
    fontWeight:"600",
    "&:hover": {
      bgcolor:"#ee0000",
      borderRadius:"10px",
      color:'#ffffff',
      transform: 'scale(1.1)',
    },
  }}
>
{tGlobal("Event.BuyTickets-prefix")}&nbsp;<WhatsappIcon/>&nbsp;{tGlobal("Event.BuyTickets-suffix")}
</Button>;
}

function getTicketingEmail(ticketingEmail, isticketable) {
  if (ticketingEmail.length===0) {
    return <></>;
  }
  return     <Button 
  variant="contained"
  href={ticketingEmail}
  disabled={!isticketable}
  sx={{
    width:{lg:"300px", md:"300px", xs:"300px"},
    height:{lg:"45px", md:"45px", xs:"45px"},
    
    bgcolor:"#ffffff",
    borderRadius:"10px",
    color:'#ee0000',
    textTransform: 'none',
    fontSize:{lg:"18px", md:"18px", xs:"18px"},
    fontWeight:"600",
    "&:hover": {
      bgcolor:"#ee0000",
      borderRadius:"10px",
      color:'#ffffff',
      transform: 'scale(1.1)',
    },
  }}
>
{tGlobal("Event.BuyTicketsEmail-prefix")}&nbsp;<MailOutlineIcon/>&nbsp;{tGlobal("Event.BuyTicketsEmail-suffix")}
</Button>;
}

function getLink(link) {
  if (link.length===0) {
    return <></>;
  }
  return     <Button 
  variant="contained"
  href={link}
  sx={{
    width:{lg:"160px", md:"160px", xs:"160px"},
    height:{lg:"45px", md:"45px", xs:"45px"},
    bgcolor:"#ffffff",
    borderRadius:"10px",
    color:'#ee0000',
    textTransform: 'none',
    fontSize:{lg:"18px", md:"18px", xs:"18px"},
    fontWeight:"600",
    "&:hover": {
      bgcolor:"#ee0000",
      borderRadius:"10px",
      color:'#ffffff',
      transform: 'scale(1.1)',
    },
  }}
>
  {tGlobal("General.RelatedLink")}
</Button>;
}

useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await fetch('/data/allEvent.json');
        const data = await response.json();
        
        const foundEvent = data.find(event => event.id === id);
        
        if (foundEvent) {
          setEvent(foundEvent);
        } else {
          navigate("/Error", { replace: true });;
        }
      } catch (error) {
        console.error('Error fetching event:', error);
        navigate("/Error", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [id, navigate]);

  if (loading) {
    return <div>Loading...</div>; 
  }

  if (!event) {
    return <Navigate to="/Error" replace />;
  }

const handleImageClick = (index) => {
  setCurrentIndex(index);
  setShowOverlay(true);
};

const handleCloseOverlay = () => {
  setShowOverlay(false);
};

const handlePrev = () => {
  setCurrentIndex((prev) => (prev === 0 ? event.image.length - 1 : prev - 1));
};

const handleNext = () => {
  setCurrentIndex((prev) => (prev === event.image.length - 1 ? 0 : prev + 1));
};

const handleThumbnailClick = (index) => {
  setCurrentIndex(index);
};



if(event ===null)
  {
    return <Navigate to={{pathname: "/Error"}}/>;
  }
  return (
    
    <Stack direction="row" sx={{justifyContent:"center", minHeight:"65.5vh", backgroundColor:"background.main"}}>
      <Fade in={true} timeout={2000}>
        <Stack direction="column" height="100%" width={{lg:"75%", md:"95%", xs:"95%"}}>
           <Stack direciton="row" justifyContent="flex-start" fontSize={{lg:"24px", md:"20px", xs:"14px"}} marginTop={{lg: "4vh", md: '3vh', xs:"2vh"}}> 
              <NavLink onClick={() => navigate(-1)}style={{textUnderlineOffset:"0.5vh", color:"#000000", fontSize:"100%"}}class="backclass">{tGlobal("General.Back")}</NavLink>
           </Stack>
           <Grid container spacing={{lg:"30px", md:"30px", xs:"20px"}} marginTop={{lg: "1vh", md: '1vh', xs:"1vh"}}>
            <Grid item lg={8} md={8} xs={12}>
              <Stack direction="row" justifyContent="flex-start">
              <Typography sx={{fontWeight:"600", color:"#DD0000", fontSize:{lg:"32px", md: "32px", xs:"24px"}}}>{event.bigTitle}</Typography>
              </Stack>

              <Stack direction="column"  marginTop={{lg: "3vh", md: '3vh', xs:"2vh"}} justifyContent="flex-start">
              <Stack direction="column" spacing={{lg:"3px", md:"2px", xs:"2px"}} justifyContent="flex-start">
                <Typography sx={{fontWeight:"400", color:"#000000", fontSize:{lg:"24px", md: "24px", xs:"18px"}}}>{event.detail}</Typography>

              </Stack>
              
              <Stack direction="column" marginTop={{lg: "3vh", md: '3vh', xs:"2vh"}} marginBottom={{lg: "1vh", md: '3vh', xs:"2vh"}}spacing={{lg:"20px", md:"20px", xs:"10px"}} width={{lg:"80%", md:"95%", xs:"100%"}} >
              {
              event.image.map((item, index) => (
                <Stack key={index} direction="row" width="100%" justifyContent={{ lg: "flex-start", md: "flex-start", xs: "center" }}>
                  <Box
                    component="img"
                    onClick={() => handleImageClick(index)}
                    sx={{
                      height: "auto",
                      display: 'block',
                      width: "100%",
                      overflow: 'hidden',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.02)',
                      },
                    }}
                    src={item}
                    alt={item}
                  />
                </Stack>
              ))
            }
            </Stack>
          </Stack>
            </Grid>
            <Grid item lg={4} md={4} xs={12} marginBottom={{lg: "1vh", md: '0vh', xs:"2vh"}}>


              <Stack direction="column"  justifyContent="flex-start">
              <Stack direction="column" spacing={{lg:"20px", md:"20px", xs:"10px"}} justifyContent="flex-start">
              {getWeekday(id)}
              {getVenue(id)}
              {getTime(id)}
              {getTicket(id)}
              {getTicketing(event.ticketing, event.isticketable)}
              {getTicketingEmail(event.ticketingEmail, event.isticketable)}
              {getLink(event.link)}
              </Stack>

              
              
              </Stack>
            </Grid>
            <Grid item container lg={12} md={12} xs={12} spacing={{lg:"10px", md:"20px", xs:"10px"}} marginBottom={{lg: "1vh", md: '0vh', xs:"2vh"}}>
            {
                event.instagram.map((item) => {
                  return(
                    <Grid item lg={4} md={6} xs={12}>
                      <InstagramEmbed url={item} width="100%" />
                      </Grid>
                  )
                }
              )}

            </Grid>
           </Grid>
        </Stack>
      </Fade>
      {showOverlay && (
        <Box
  sx={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    bgcolor: 'rgba(0, 0, 0, 0.85)',
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: { xs: 2, sm: 3, md: 4 }, // add padding for small screens
    boxSizing: 'border-box',
  }}
>
  {/* Top info */}
  <Box
  sx={{
    position: 'absolute',
    top: { xs: 12, sm: 16 },
    right: { xs: 12, sm: 24 },
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    px: 2,
    py: 0.5,
    borderRadius: '12px',
    fontWeight: 'bold',
    fontSize: { lg: '18px', md: '16px', xs: '12px' },
    maxWidth: 'fit-content',
    zIndex: 2,
    whiteSpace: 'nowrap',
  }}
>
  {currentIndex + 1} / {event.image.length}
</Box>
    {/* Close button */}
    <IconButton
  onClick={handleCloseOverlay}
  sx={{
    position: 'absolute',
    top: { xs: 12, sm: 16 },
    left: { xs: 12, sm: 16 },
    color: 'white',
    zIndex: 2,
  }}
>
  <CloseIcon />
</IconButton>

  {/* Main Image */}
  <Box
  sx={{
    position: 'relative',
    width: '100%',
    maxWidth: 1000, // Allow wider images
    height: { xs: '70vh', sm: '75vh', md: '80vh' }, // Bigger heights
    mb: 2,
    px: { xs: 2, sm: 4 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  {/* Prev button */}
  <IconButton
    onClick={handlePrev}
    sx={{
      position: 'absolute',
      left: {lg:"-10vw",md:3, xs:"1vw"},
      color: 'white',
      zIndex: 2,
      backgroundColor: 'rgba(0,0,0,0.4)',
      '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
    }}
  >
    <ArrowBackIosNewIcon fontSize="large" />
  </IconButton>

  {/* Main Image */}
  <img
    src={event.image[currentIndex]}
    alt={`Gallery ${currentIndex}`}
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: 10,
    }}
  />

  {/* Next button */}
  <IconButton
  onClick={handleNext}
  sx={{
    position: 'absolute',
    right: {lg:"-10vw", xs: 8, sm: 16 },
    color: 'white',
    zIndex: 2,
    backgroundColor: 'rgba(0,0,0,0.4)',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
  }}
>
  <ArrowForwardIosIcon fontSize="large" />
</IconButton>
    </Box>

    {/* Thumbnail scroll bar */}
    <Box sx={{ position: 'relative', width: '90%', maxWidth: 1200 }}>
      <IconButton
        onClick={() => document.getElementById("thumbnail-scroll").scrollBy({ left: -150, behavior: 'smooth' })}
        sx={{ position: 'absolute', left: -10, top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: 'white', bgcolor: 'rgba(0,0,0,0.3)' }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      <IconButton
        onClick={() => document.getElementById("thumbnail-scroll").scrollBy({ left: 150, behavior: 'smooth' })}
        sx={{ position: 'absolute', right: -10, top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: 'white', bgcolor: 'rgba(0,0,0,0.3)' }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      <Box
        id="thumbnail-scroll"
        sx={{
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          py: 1,
          px: 4,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {event.image.map((img, index) => (
          <Box
            key={index}
            component="img"
            src={img}
            alt={`Thumb ${index}`}
            onClick={() => handleThumbnailClick(index)}
            sx={{
              width: 80,
              height: 80,
              mx: 1,
              borderRadius: 2,
              border: currentIndex === index ? '3px solid white' : '2px solid transparent',
              cursor: 'pointer',
              objectFit: 'cover',
              display: 'inline-block',
              transition: 'transform 0.3s ease',
              '&:hover': { transform: 'scale(1.05)' },
            }}
          />
        ))}
      </Box>
    </Box>
  </Box>
)}
    </Stack>
  )
}export default Transition(Event);


